import { classed } from "@trydig/ui";
import styles from "./Prose.module.css";

export const Prose = classed("div", styles.root);
